import * as React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import * as styles from './Tabs.module.scss';

const Tab = ({ children, isActive }) => {
  return (
    <li className={cn(styles.Tab, { [styles.Tab_active]: isActive })}>
      {children}
    </li>
  );
};

Tab.propTypes = {
  children: PropTypes.element.isRequired,
  isActive: PropTypes.bool
};

Tab.defaultProps = {
  isActive: false
};

export default Tab;
